export default __webpack_public_path__ + "static/media/covertwo.9748080c.txt";